import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Dataset, DatasetsRequest, DatasetRegion } from 'src/app/modules/core/store/models/dataset.model';
import { QueryParams, QueryResult } from 'src/app/modules/core/store/models/query.model';
import { HttpService } from 'src/app/modules/core/services/http.service';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class DatasetApiService {
  constructor(private http: HttpService) {}

  public createDataset(dataset: Dataset): Observable<Dataset> {
    const url = `${apiBaseUrl}/v1/meta/datasets/`;

    return this.http.post(url, dataset);
  }

  public getDatasets(
    params: QueryParams,
    includeWorkflow?: boolean,
    skipChildren?: boolean,
    datasetUIds?: string[]
  ): Observable<QueryResult<Dataset>> {
    const datasetsRequestDto = {
      ...params,
      includeWorkflow: !!includeWorkflow,
      skipChildren: !!skipChildren,
      datasetUIds: datasetUIds
    } as DatasetsRequest;

    const url = `${apiBaseUrl}/v1/meta/datasets/query`;

    return this.http.post(url, datasetsRequestDto);
  }

  public getDataset(datasetUid: string, params?: any): Observable<Dataset> {
    const queryString = this.http.queryStringFromObject(params || {});

    const url = `${apiBaseUrl}/v1/meta/datasets/${datasetUid}?${queryString}`;

    return this.http.get<Dataset>(url);
  }

  public deleteDataset(dataset: Dataset): Observable<void> {
    const url = `${apiBaseUrl}/v1/meta/datasets/${dataset.uId}`;

    return this.http.delete(url);
  }

  public updateDataset(dataset: Dataset): Observable<Dataset> {
    const url = `${apiBaseUrl}/v1/meta/datasets/${dataset.uId}`;

    return this.http.put(url, dataset);
  }

  public getDatasetRegions(onlyIsActive: boolean): Observable<DatasetRegion[]> {
    const url = `${apiBaseUrl}/v1/meta/datasets/regions?onlyIsActive=${onlyIsActive}`;

    return this.http.get(url);
  }
}
